export const GetInTouchConst = {
  FETCH_ALL_REQUEST: "SA_FETCH_ALL_GET_IN_TOUCH_REQUEST",
  FETCH_ALL_SUCCESS: "SA_FETCH_ALL_GET_IN_TOUCH_SUCCESS",
  FETCH_ALL_FAIL: "SA_FETCH_ALL_GET_IN_TOUCH_FAIL",

  CLEAR_ACTION: "SA_GET_IN_TOUCH_CLEAR_ACTION",
};
